// fields which will use a date input and must be converted
// to a date filter on the target list page interface
// cols headers that than be highlitable when user types something in the search bar
// it indicates in which fields the backend will look. Its a UI perk for the user
// WARNING: backend must be adadpted and correspond if these are changed in front or back
export const HIGHLIGHTABLE_COL_HEADERS_ON_SEARCH = ['projectName', 'actionCode', 'populationSample', 'advertId']
